import React, { useState, useEffect } from "react";

import SendType from "./SendType";
import RecepientForm from "./RecepientForm";
import { adminRole } from "../../constants/AppConstant";

import { Banner, Button, Card, Icon } from "@plum-xoxo/admin-dsm";
import { Row } from "reactstrap";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";
import "./recepients.scss";
import RecepientDataComponent from "./RecipientDataComponent";
import DeleteUserConfirmation from "../Modals/DeleteUserConfirmation";
import BulkProcess from "../BulkProcess";
import { StyledIcon } from "../../modules/Accounts/PlatformPreferences/Component/styled";
import { app_path } from "config";
import SendMode from "./SendMode";

const StyledCard = styled(Card).attrs()``;

const AddEditRecipientCommon = (props) => {
  const {
    rewardType,
    sendXoxoCodePdf,
    role,
    currencyCode = "INR",
    recipientType,
    setRecipientType,
    recipientData,
    setRecipientData,
    updateScheduleCount,
    setSelectedCountry,
    nonScheduledAmount,
    finalTotal,
    setFinalTotal,
    expiryMonth,
    selectedSite,
    selectedTemplate,
    emailLogo,
    emailHeading,
    emailTitle,
    emailSubject,
    customColor,
    setCustomColor,
    smsText,
    buttonText,
    isFileUploaded,
    setIsFileUploaded,
    templateId,
    verifyFile,
    setVerifyFile,
    uploadFileData,
    setUploadFileData,
    setError,
    setDisabled,
    startBulk,
    setStartBulk,
    GenerateForSelf,
    GrandTotalToolTipWithProps,
    grandTotal,
    countryList,
    selectedCountry,
    countryListLoading,
    getPoNumbers,
    voucherList,
    accountReducer,
    productLoader,
    calculatePayable,
    setGrandTotal,
    campaignId,
    sendMode,
    setSendMode,
    nonScheduleCount,
    handleReset,
    setBulkSuccess,
    distributionType,
    setNonScheduledAmount,
    setNonScheduleCount,
    setScheduleAmount,
    setScheduleCount,
    linksQty,
    setLinksQty,
    maxSplCharge,
    rechargeMaxLimit,
    rechargeMaxLimitError,
    whatsappText = "",
    whatsappAlbumImageId = "0",
    setBulkUploadError,
    setActiveTab
  } = props;

  const [userDataIndex, setUserDataIndex] = useState(1);
  const [editUserId, setEditUserId] = useState(0);
  const [addMore, setAddMore] = useState(false);
  const [isEditUserEnabled, setIsEdituserEnabled] = useState(false);
  const [openDeleteUserModal, setOpenDeleteUserModal] = useState(false);
  const [toBeRemovedUser, setToBeRemovedUser] = useState();
  const { authentication_type = 0 } = props;

  const handleDeleteUserClick = (el) => {
    const data = recipientData.find((user) => user.id === el.id);
    if (rewardType === 4) {
      data.name = data.email;
    }

    setToBeRemovedUser(data);
    setOpenDeleteUserModal(true);
  };

  const confirmDeleteUser = () => {
    const indexNo = recipientData.findIndex(
      (user) => user.id === toBeRemovedUser.id
    );
    const newReceipientData = recipientData.filter(
      (ele, index) => index !== indexNo
    );
    let localFinalTotal;
    if (rewardType === 1 || rewardType === 2) localFinalTotal = finalTotal;
    else localFinalTotal = grandTotal;
    localFinalTotal -= toBeRemovedUser.total;
    if (rewardType === 1 || rewardType === 2)
      updateScheduleCount(newReceipientData);

    setOpenDeleteUserModal(false);
    setRecipientData(newReceipientData);
    if (rewardType === 3 || rewardType === 4) setGrandTotal(localFinalTotal);
    else setFinalTotal(localFinalTotal);
    setToBeRemovedUser({});
  };

  useEffect(() => {
    if (isEditUserEnabled || addMore) setDisabled(true);
  }, [isEditUserEnabled, addMore]);

  const handleEditUserData = (el) => {
    setIsEdituserEnabled(true);
    setEditUserId(el.id);
  };

  const showSendMode = () => {
    if (recipientType === 0) {
      return rewardType === 1 || rewardType === 2;
    } else if (recipientType === 1) {
      return rewardType !== 4;
    }
  };

  return (
    <>
      <StyledCard
        className={`d-flex flex-column mt-16 ${
          isEditUserEnabled || addMore ? "mb-0" : "mb-74"
        }`}
      >
        {rewardType !== 2 && (
          <>
            <div className="d-flex px-24 py-16">
              <div className="d-flex align-items-center">
                <StyledIcon
                  iconName="PlumRecipient"
                  color="primary"
                  shade="c02"
                  size={16}
                  className="mr-16"
                />
                <div>
                  <Typography.H3 color="dark" shade="c300">
                    Add Recipients
                  </Typography.H3>
                </div>
              </div>
            </div>
            <hr className="m-0" />
          </>
        )}
        <SendType
          recipientType={recipientType}
          setRecipientType={setRecipientType}
          recipientData={recipientData}
          isFileUploaded={isFileUploaded}
          setRecipientData={setRecipientData}
          uploadFileData={uploadFileData}
          setUploadFileData={setUploadFileData}
          setIsFileUploaded={setIsFileUploaded}
          setError={setError}
          rewardType={rewardType}
          setDisabled={setDisabled}
          setBulkSuccess={setBulkSuccess}
          setNonScheduledAmount={setNonScheduledAmount}
          setNonScheduleCount={setNonScheduleCount}
          setScheduleAmount={setScheduleAmount}
          setScheduleCount={setScheduleCount}
          linksQty={linksQty}
          setLinksQty={setLinksQty}
          setGrandTotal={setGrandTotal}
          setIsEditUserEnabled={setIsEdituserEnabled}
          setAddMore={setAddMore}
          handleReset={handleReset}
        />
        {showSendMode() && (
          <>
            <SendMode
              sendMode={sendMode}
              setSendMode={setSendMode}
              rewardType={rewardType}
              currencyCode={currencyCode}
              clientId={accountReducer?.clientId}
              recipientData={recipientData}
              isEditUserEnabled={isEditUserEnabled}
              authentication_type={authentication_type}
            />
            {sendMode?.length === 1 && sendMode?.includes("whatsapp") && (
              <div className="px-24 py-20">
                <Banner
                  iconName=""
                  color="info"
                  description={
                    <>
                      <Typography.LabelText component="span">
                        Please Note:{" "}
                      </Typography.LabelText>
                      <Typography.HelperText component="span">
                        If the reward delivery via WhatsApp fails, it will be
                        resent via SMS to the same mobile number.
                      </Typography.HelperText>
                    </>
                  }
                  buttons={
                    <>
                      <Icon
                        size={16}
                        iconName="Close"
                        color="dark"
                        shade="c300"
                      />
                    </>
                  }
                />
              </div>
            )}
          </>
        )}
        <div
          className={`${recipientType === 0 ? "" : "d-none"} px-24 pt-12 pb-24`}
        >
          <BulkProcess
            setActiveTab={setActiveTab}
            setBulkUploadError={setBulkUploadError}
            reward_type={rewardType}
            history={props.history}
            authentication_type={authentication_type}
            expiryMonth={expiryMonth}
            selectedSite={selectedSite}
            selectedTemplate={selectedTemplate}
            emailLogo={emailLogo}
            emailHeading={emailHeading}
            emailTitle={emailTitle}
            emailSubject={emailSubject}
            customColor={customColor}
            setCustomColor={setCustomColor}
            buttonText={buttonText}
            smsText={smsText}
            templateId={templateId}
            isFileUploaded={isFileUploaded}
            setIsFileUploaded={setIsFileUploaded}
            verifyFile={verifyFile}
            setVerifyFile={setVerifyFile}
            uploadFileData={uploadFileData}
            setUploadFileData={setUploadFileData}
            startBulk={startBulk}
            setStartBulk={setStartBulk}
            campaignId={campaignId}
            handleReset={handleReset}
            setBulkSuccess={setBulkSuccess}
            setDisabled={setDisabled}
            distributionType={distributionType}
            whatsappText={whatsappText}
            whatsappAlbumImageId={whatsappAlbumImageId}
            sendMode={sendMode}
          />
        </div>
        <div className={`${recipientType === 2 ? "" : "d-none"} p-24`}>
          {GenerateForSelf}
        </div>
        <div className={`${recipientType === 1 ? "" : "d-none"}`}>
          {recipientData.length > 0 && (
            <>
              <div className="m-24">
                <Row className="px-24">
                  <Typography.ButtonText>
                    {recipientData.length > 1 ? `Recipients` : `Recipient`}{" "}
                    {`(${recipientData.length})`}
                  </Typography.ButtonText>
                </Row>
                <Row>
                  {recipientData.map((el, index) => {
                    return editUserId !== el.id ? (
                      <RecepientDataComponent
                        key={index}
                        handleDeleteUserClick={handleDeleteUserClick}
                        handleEditUserData={handleEditUserData}
                        index={index}
                        recipient={el}
                        currencyCode={currencyCode}
                        addMore={addMore}
                        isEditUserEnabled={isEditUserEnabled}
                        rewardType={rewardType}
                        selectedSite={selectedSite}
                        sendMode={sendMode}
                      />
                    ) : null;
                  })}
                </Row>
              </div>
              {!isEditUserEnabled && recipientData.length && !addMore && (
                <>
                  {" "}
                  <hr />
                  <div className="d-flex justify-content-between align-items-center px-24 pb-24">
                    <div>
                      {(rewardType == 1 || rewardType === 2) &&
                        nonScheduleCount > 0 && (
                          <Typography.H3
                            color="dark"
                            shade="c300"
                            className="align-items-center"
                          >
                            Grand Total: {currencyCode}{" "}
                            {nonScheduledAmount.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </Typography.H3>
                        )}
                      {((rewardType == 3 && distributionType === 1) ||
                        rewardType === 4) && (
                        <Typography.H3
                          color="dark"
                          shade="c300"
                          className="d-flex align-items-center"
                        >
                          Grand Total: {currencyCode}{" "}
                          {parseFloat(grandTotal).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}
                          {rewardType === 3 &&
                            maxSplCharge &&
                            GrandTotalToolTipWithProps}
                        </Typography.H3>
                      )}
                      {rechargeMaxLimitError && role == adminRole.superAdmin ? (
                        <Typography.HelperText
                          color="red"
                          shade="c300"
                          className="align-items-center d-flex flex-row"
                        >
                          Insufficient balance in your account. Please{" "}
                          <a
                            onClick={() =>
                              props.history.push(`/${app_path}/recharge`)
                            }
                          >
                            <Typography.HelperText
                              color="primary"
                              shade="c02"
                              component={"span"}
                              className="ml-4 mr-4"
                            >
                              add funds{" "}
                            </Typography.HelperText>
                          </a>
                          to your account to proceed.
                        </Typography.HelperText>
                      ) : null}
                    </div>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => {
                        setAddMore(!addMore);
                      }}
                    >
                      Add More
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
          {recipientData.length === 0 && (
            <>
              <RecepientForm
                sendMode={sendMode}
                setSendMode={setSendMode}
                sendXoxoCodePdf={sendXoxoCodePdf}
                userDataIndex={userDataIndex}
                setUserDataIndex={setUserDataIndex}
                addMore={addMore}
                setAddMore={setAddMore}
                recipientData={recipientData}
                setRecipientData={setRecipientData}
                finalTotal={finalTotal}
                setFinalTotal={setFinalTotal}
                updateScheduleCount={updateScheduleCount}
                currencyCode={currencyCode}
                setIsEdituserEnabled={setIsEdituserEnabled}
                isEditUserEnabled={isEditUserEnabled}
                editUserId={editUserId}
                setEditUserId={setEditUserId}
                authentication_type={authentication_type}
                setDisabled={setDisabled}
                rewardType={rewardType}
                countryList={countryList}
                countryListLoading={countryListLoading}
                setSelectedCountry={setSelectedCountry}
                selectedCountry={selectedCountry}
                voucherList={voucherList}
                accountReducer={accountReducer}
                calculatePayable={calculatePayable}
                productLoader={productLoader}
                setGrandTotal={setGrandTotal}
                getPoNumbers={getPoNumbers}
                selectedSite={selectedSite}
                location={props.location}
              />
            </>
          )}
        </div>
      </StyledCard>
      {recipientType === 1 && (addMore || isEditUserEnabled) && (
        <StyledCard className="mt-16 mb-72">
          <RecepientForm
            sendMode={sendMode}
            setSendMode={setSendMode}
            sendXoxoCodePdf={sendXoxoCodePdf}
            userDataIndex={userDataIndex}
            setUserDataIndex={setUserDataIndex}
            addMore={addMore}
            setAddMore={setAddMore}
            recipientData={recipientData}
            setRecipientData={setRecipientData}
            finalTotal={finalTotal}
            setFinalTotal={setFinalTotal}
            updateScheduleCount={updateScheduleCount}
            currencyCode={currencyCode}
            setIsEdituserEnabled={setIsEdituserEnabled}
            isEditUserEnabled={isEditUserEnabled}
            editUserId={editUserId}
            setEditUserId={setEditUserId}
            authentication_type={authentication_type}
            setDisabled={setDisabled}
            rewardType={rewardType}
            countryList={countryList}
            countryListLoading={countryListLoading}
            setSelectedCountry={setSelectedCountry}
            selectedCountry={selectedCountry}
            voucherList={voucherList}
            accountReducer={accountReducer}
            productLoader={productLoader}
            calculatePayable={calculatePayable}
            setGrandTotal={setGrandTotal}
            getPoNumbers={getPoNumbers}
            selectedSite={selectedSite}
          />
        </StyledCard>
      )}
      {openDeleteUserModal && (
        <DeleteUserConfirmation
          closeModal={() => setOpenDeleteUserModal(false)}
          toBeRemovedUser={toBeRemovedUser}
          removeUser={() => confirmDeleteUser()}
        />
      )}
    </>
  );
};

export default AddEditRecipientCommon;
